import { defaultsDeep } from "lodash";

function updateSubscriptionVoucherCerts() {
  console.log('method: updateSubscriptionVoucherCerts')
  let certs = $('#myRange').val()
  let plan = $('#term').val()


  $('#certs').html(certs)
  let resp = calculatePricing(certs, plan)
  if (resp.costPerYear > 0) {

    $('#price').val(resp.costPerYear)
  } else {

    $('#price').val(resp.costPerMonth)
  }
}
function updateSubscriptionVoucher() {
  console.log("updateSubscriptionVouchers started")
  let voucher_range = document.getElementById('voucher-range').value;
  if (voucher_range != 1) {
    voucher_range = voucher_range - 1;
  }
  let form = document.getElementById('new-subscription-modal')
  let certs = $('#myRange').val();
  let plan = form.elements["term"].value

  let cert_text = document.getElementById('cert_text');
  cert_text.innerHTML = certs;
  if (plan == "monthly") {

    let time_span = document.getElementById('time_span');
    time_span.innerHTML = "1 month";
  }
  else if (plan == "yearly") {

    let time_span = document.getElementById('time_span');
    time_span.innerHTML = "1 year";
  }
  else if (plan == "2years") {

    let time_span = document.getElementById('time_span');
    time_span.innerHTML = "2-year";
  }
  else if (plan == "3years") {
    let time_span = document.getElementById('time_span');
    time_span.innerHTML = "3-year";
  }

  $('#certs').html(certs)

  let resp = calculatePricing(certs, plan)

  if (resp.costPerYear > 0) {
    let pricing = document.getElementById('pricing');
    pricing.innerHTML = (resp.costPerYear).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    let subTotalElement = document.getElementById('sub_total');
    let sub_total = voucher_range * resp.costPerYear;
    
    // Format the total as a currency string
    let formattedTotal = sub_total.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    
    // Set the innerHTML of the sub_total element to the formatted total
    subTotalElement.innerHTML = formattedTotal;
    var sub_discounted = resp.costPerYear * 7;
    sub_discounted = sub_discounted / 100;
    var sub_amount = resp.costPerYear - sub_discounted;

    $('#price').val((sub_amount).toFixed(2));
    let total = document.getElementById('total');
    var discounted = resp.costPerYear * 7;
    discounted = discounted / 100;
    var amount = resp.costPerYear - discounted;
    total.innerHTML = (voucher_range * amount).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  } else {
    let pricing = document.getElementById('pricing');
    pricing.innerHTML = resp.costPerMonth.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    let sub_total = document.getElementById('sub_total');
    sub_total.innerHTML = (voucher_range * resp.costPerMonth).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    var sub_discounted = resp.costPerMonth * 7;
    sub_discounted = sub_discounted / 100;
    var sub_amount = resp.costPerMonth - sub_discounted;
    $('#price').val(sub_amount.toFixed(2));
    let total = document.getElementById('total');
    var discounted = resp.costPerMonth * 7;
    discounted = discounted / 100;
    var amount = resp.costPerMonth - discounted;
    total.innerHTML = (voucher_range * amount).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
  $("#vouchers-modal").modal('show');
}

function editVouchersPaymentMethod() {
  $("#vouchers-modal").modal('hide')
  $("#payment-method-update").modal('show')
}

function updateVouchersCount() {

  let voucher_range = document.getElementById('voucher-range').value;
  if (voucher_range != 1) {
    voucher_range = voucher_range - 1;
  }
  $('#vouchers').html(voucher_range)
  let quantity = document.getElementById('quantity');
  quantity.innerHTML = "QTY " + voucher_range;
  let form = document.getElementById('new-subscription-modal')
  let certs = $('#myRange').val()
  let plan = form.elements["term"].value
  $('#certs').html(certs)

  let resp = calculatePricing(certs, plan)

  if (resp.costPerYear > 0) {
    let sub_total = document.getElementById('sub_total');
    sub_total.innerHTML = (voucher_range * resp.costPerYear).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    let total = document.getElementById('total');
    var discounted = resp.costPerYear * 7;
    discounted = discounted / 100;
    var amount = resp.costPerYear - discounted;

    total.innerHTML = (voucher_range * amount).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  }
  else {
    let sub_total = document.getElementById('sub_total');
    sub_total.innerHTML = (voucher_range * resp.costPerMonth).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
    let total = document.getElementById('total');
    var discounted = resp.costPerMonth * 7;
    discounted = discounted / 100;
    var amount = resp.costPerMonth - discounted;

    total.innerHTML = (voucher_range * amount).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });


  }

}


function showPaymentErrorModalForVouchers() {
  $("#error-modal").modal('show')
  $('#error-title').html("Credit Card Error")
  $('#error-body').html("No credit card found associated with your account, please update your card details")
}


// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const brokerSubscriptionModule = {
  updateSubscriptionVoucher,
  updateVouchersCount,
  showPaymentErrorModalForVouchers,
}